export interface MenuProps {
  name: string;
  path: string;
}

export interface SettingsTabProps {
  label: string;
  value: string;
}

export const menu: MenuProps[] = [
  {
    name: 'Balances',
    path: '/balances',
  },
  {
    name: 'Transactions',
    path: '/transactions?page=1',
  },
  {
    name: 'Customers',
    path: '/customers',
  },
  // {
  //   name: 'Settings',
  //   path: '/settings',
  // },
];

export const settingsTab: SettingsTabProps[] = [
  {
    label: 'Profile',
    value: 'profile',
  },
  {
    label: 'Team',
    value: 'team',
  },
  {
    label: 'Developers',
    value: 'developers',
  },
  {
    label: 'Configuration',
    value: 'configuration',
  },
];

export const allowedPaths = [
  '/',
  '/transactions',
  '/transactions/',
  '/transaction',
];

export const PER_PAGE = 20;

export const AUTH_STORAGE_KEY = 'merchant';

export const txnStatusOptions = [
  { label: 'Success', value: 'completed' },
  { label: 'Failed', value: 'failed' },
  { label: 'Pending', value: 'pending' },
  { label: 'Processing', value: 'processing' },
  { label: 'Retried', value: 'retried' },
];
export const txnCurrencyOptions = [
  { label: 'NGN', value: 'NGN' },
  { label: 'USD', value: 'USD' },
];
export const txnTypeOptions = [
  { label: 'Withdraw', value: 'Withdraw' },
  { label: 'Deposit', value: 'Deposit' },
  { label: 'Onramp', value: 'OnRamp' },
  { label: 'Offramp', value: 'OffRamp' },
  { label: 'Transfer', value: 'Transfer' },
  { label: 'Convert', value: 'Convert' },
];

export const filterDateOptions = [
  {
    label: 'Today',
    value: 'today',
  },
  {
    label: 'Last 7 days',
    value: '7days',
  },
  {
    label: 'This month',
    value: 'thisMonth',
  },
  {
    label: 'Last month',
    value: 'lastMonth',
  },
];

export const APIKEY_PERMISSIONS = [
  {
    label: 'Admin',
    value: 'M',
  },
  {
    label: 'Manager',
    value: 'N',
  },
  {
    label: 'Withdraw Only',
    value: 'W',
  },
  {
    label: 'Read Only',
    value: 'G',
  },
];

export const TEAM_PERMISSIONS = [
  {
    label: 'Super admin',
    value: 'superAdmin',
  },
  {
    label: 'Settings admin',
    value: 'settingsAdmin',
  },
  {
    label: 'Operations',
    value: 'operations',
  },
  {
    label: 'View only',
    value: 'viewOnly',
  },
];

export const MERCHANT = 'merchant';

export const USER_AUTH = 'userAuth';

export const COMPLETED = 'completed';

export const PROCESSING = 'processing';

export const SUCCESS = 'Success';

export const PENDING = 'pending';

export const FAILED = 'Failed';

export const FIAT_LIST = ['USD', 'NGN', 'GHS', 'KES'];
